// Index.js
export const CHANGE_LEVEL = 'CHANGE_LEVEL'
export const CHANGE_BUILDING = 'CHANGE_BUILDING'
export const CHANGE_COMPLEX = 'CHANGE_COMPLEX'
export const CHANGE_POI = 'CHANGE_POI'
export const CHANGE_ROOM = 'CHANGE_ROOM'
export const CHANGE_REAL_ESTATE = 'CHANGE_REAL_ESTATE'
export const RESET_ALL_SELECTIONS = 'RESET_ALL_SELECTIONS'
export const RESET_PLANVIEW_SELECTIONS = 'RESET_PLANVIEW_SELECTIONS'
export const GET_POI_PRODUCT = 'GET_POI_PRODUCT'
export const GET_USERS_FOR_REALM = 'GET_USERS_FOR_REALM'
export const IMPORT_STATE = 'IMPORT_STATE'
// Indoorviewer.js
export const CHANGE_LEVEL_IV = 'CHANGE_LEVEL_IV'
export const CHANGE_LEVEL_IV_FRAME2 = 'CHANGE_LEVEL_IV_FRAME2'
export const GET_POIS_FOR_SELECTED_BUILDING = 'GET_POIS_FOR_SELECTED_BUILDING'
export const LOAD_IV_COMPONENTS = 'LOAD_IV_COMPONENTS'
export const INIT_CONTEXTMENU = 'INIT_CONTEXTMENU'
export const INIT_FLOORS = 'INIT_FLOORS'
export const INIT_DISRUPTIVE_SENSORS = 'INIT_DISRUPTIVE_SENSORS'
export const RESET_IVION_INSTANCES = 'RESET_IVION_INSTANCES'
export const SET_IV_LEVELS = 'SET_IV_LEVELS'
export const IV_SET_CURRENT_FLOOR = 'IV_SET_CURRENT_FLOOR'

// Mapview.js
export const CHANGE_REGION = 'CHANGE_REGION'
export const GET_POI_CATEGORIES_FOR_SELECTED_BUILDING = 'GET_POI_CATEGORIES_FOR_SELECTED_BUILDING'
export const GET_OUTDOOR_POI_DATA_FOR_REAL_ESTATE = 'GET_OUTDOOR_POI_DATA_FOR_REAL_ESTATE'
export const GET_OUTDOOR_ZONE_DATA_FOR_REAL_ESTATE = 'GET_OUTDOOR_ZONE_DATA_FOR_REAL_ESTATE'
export const RESET_CURRENT_REAL_ESTATE = 'RESET_CURRENT_REAL_ESTATE'
export const COMPLEX_CLICKED = 'COMPLEX_CLICKED'

// Planview.js
export const GET_INDOOR_ZONE_DATA_FOR_LEVEL = 'GET_INDOOR_ZONE_DATA_FOR_LEVEL'
export const GET_ROOMS_FOR_SELECTED_LEVEL = 'GET_ROOMS_FOR_SELECTED_LEVEL'
export const GET_POI_CATEGORIES_FOR_SELECTED_LEVEL = 'GET_POI_CATEGORIES_FOR_SELECTED_LEVEL'
export const RESET_CURRENT_LEVEL = 'RESET_CURRENT_LEVEL'

// Dashboardview.js
export const CHANGE_COMPLEX_DASHBOARD = 'CHANGE_COMPLEX_DASHBOARD'
export const CHANGE_REAL_ESTATE_DASHBOARD = 'CHANGE_REAL_ESTATE_DASHBOARD'
export const CHANGE_BUILDING_DASHBOARD = 'CHANGE_BUILDING_DASHBOARD'
export const CHANGE_LEVEL_DASHBOARD = 'CHANGE_LEVEL_DASHBOARD'
export const RESET_DASHBOARD_FILTER = 'RESET_DASHBOARD_FILTER'
